import React, {FC} from "react"

import Close from "@irati/ui/src/Close"

import {ToastErrorContainer} from "./styled"

interface Props {
  onClose: () => void
}

const ToastError: FC<Props> = ({children, onClose}) => {
  return (
    <ToastErrorContainer>
      <Close onClick={onClose} top="16px" right="16px" />
      {children}
    </ToastErrorContainer>
  )
}

export default ToastError
